import styles from "./SharedGallery.module.css";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import { useParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
const SharedGallery = (props) => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const image_base_url = `${backend_base}/media/`;
  console.log("SHARED GALLERY ID:");
  const { id } = useParams();
  console.log(id);
  const [password, setPassword] = useState("");
  const [showGallery, setShowGallery] = useState(false);
  const [title, setTitle] = useState("");
  const [images, setImages] = useState([]);
  const getGallery = () => {
    console.log(password);
    console.log(id);
    axios
      .post(backend_base + "/shop/album/shared/" + id, {
        password: password,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Shared Album");
          console.log(res.data);
          setTitle(res.data.name);
          setImages(res.data.images);
          setShowGallery(true);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  return (
    <>
      <Header />
      <div
        style={{ display: showGallery ? "" : "none" }}
        className={styles.main_div}
      >
        <div className={styles.header_title}>{title}</div>
        <div className={styles.images_section}>
          {
      Array.isArray(images) &&
      images.length > 0 && images.map((item, index) => {
            return (
              <div
                className={styles.image_section_single_image_main}
                key={index}
              >
                <img
                  className={styles.image_section_single_image}
                  src={image_base_url + item.location}
                  alt="album_image"
                />
              </div>
            );
          })}
        </div>
      </div>

      <div
        style={{ display: showGallery ? "none" : "" }}
        className={styles.main_div_pass}
      >
        <div className={styles.password_main_div}>
          <div className={styles.password_header_text}>
            ギャラリー共有用パスワード
          </div>
          <input
            className={styles.password_input}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            type="password"
          />
          <div
            onClick={() => {
              getGallery();
            }}
            className={styles.button1}
          >
            ギャラリーを見る
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SharedGallery;
